// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1XXAJ","itemTitle":"ClientEmergencyInfo_itemTitle__1cc-4","itemText":"ClientEmergencyInfo_itemText__2ruFF"};